// extracted by mini-css-extract-plugin
export default {"custom-radio":"styles_custom-radio__TVWgw","bigger":"styles_bigger__bnOKd","tds-radio":"styles_tds-radio__E1Nbj","custom-radio-span":"styles_custom-radio-span__p4dbX"};